import React from "react";
import ErrorSVG from "../Assets/Error.svg";
import Typography from "@material-ui/core/Typography";

function Error404() {
  return (
    <div style={{display:'flex',flexWrap:'wrap',flexDirection:'row',width:'80%',margin:'auto'}}>
        <div style={{width:'300px',maxWidth:'100vw'}}>
        <Typography color="primary" variant ="h2">ERROR 404</Typography>      
      <Typography variant ="h3" color="secondary">PAGE NOT FOUND</Typography>
      </div>
      <img src={ErrorSVG}  style={{maxWidth:'600px',width:'auto'}}/>
    </div>
  );
}

export default Error404;
